import { parseAsStringLiteral, useQueryState } from "nuqs";
import { useEffect } from "react";
import { UTILITY_KIND, type UtilityKind } from "../models/Utility";

const UTILITY_KINDS = Object.values(UTILITY_KIND);

export const useUtilityKind = (available: UtilityKind[]) => {
	const [param, setParam] = useQueryState(
		"utility",
		parseAsStringLiteral(UTILITY_KINDS)
			.withDefault(UTILITY_KIND.WATER)
			.withOptions({ clearOnDefault: false }),
	);

	const utility = available.includes(param) ? param : available[0];

	useEffect(() => {
		if (param !== utility) setParam(utility);
	}, [param, utility]);

	return [utility, (next: UtilityKind) => setParam(next)] as const;
};
